import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Kolkata');

platformBrowser()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch(err => console.error(err));
